import { BelongRepository } from '../domain/repositories/BelongRepository'
import { BelongDatasource } from './datasources/BelongDatasource'

export const belongRepositoryAdapter = (
  belongDatasource: BelongDatasource
): BelongRepository => {
  return {
    async updateOutgoingSetting() {
      return await belongDatasource.updateOutgoingSetting()
    },
    async updateIncomingSetting() {
      return await belongDatasource.updateIncomingSetting()
    },
    async updatePreparingSetting() {
      return await belongDatasource.updatePreparingSetting()
    },
    async settings() {
      return await belongDatasource.settings()
    },
    async listItem() {
      return await belongDatasource.listItem()
    },
    async createItem(data) {
      return await belongDatasource.createItem(data)
    },
    async deleteItem(itemId) {
      return await belongDatasource.deleteItem(itemId)
    },

    async getDateBelongReport(patientId, date) {
      return belongDatasource.getDateBelongReport(patientId, date)
    },
    async getWeekBelongReport(patientId, date) {
      return belongDatasource.getWeekBelongReport(patientId, date)
    },
    async getMonthBelongReport(patientId, month, year) {
      return belongDatasource.getMonthBelongReport(patientId, month, year)
    },
    async getSemesterBelongReport(patientId, year, semester) {
      return belongDatasource.getSemesterBelongReport(patientId, year, semester)
    },
    async getCustomBelongReport(patientId, startDate, endDate) {
      return belongDatasource.getCustomBelongReport(
        patientId,
        startDate,
        endDate
      )
    },

    async getPendingList() {
      return await belongDatasource.getPendingList()
    },
    async getItemsList(patientId) {
      return await belongDatasource.getItemsList(patientId)
    },

    async updateStatusItem(itemId, status) {
      return await belongDatasource.updateStatusItem(itemId, status)
    }
  }
}
